async function recordPurchase(transaction_id, value, items=[]) {
  value = parseFloat(value);

  // Records metrics associated with a purchase event in all our analytics trackers
  // - transaction_id: a unique string ID for this transaction, corresponds to the 'payment' ID in our DB
  // - value: the value of the purchase in USD as a float or string
  // - items: an array of objects like { id: <str>, price: <float> }

  // Report to Facebook
  // https://developers.facebook.com/docs/facebook-pixel/implementation/conversion-tracking/
  // TODO: it might be useful to additionally report the actual products that were purchased, but I think that
  // requires some additional information to include the products in Facebook's commerce manager. Find more
  // information here:
  // https://developers.facebook.com/docs/facebook-pixel/implementation/dynamic-ads/
  // You can verify that these metrics are being reported correctly in the Facebook Events Manager:
  // https://business.facebook.com/events_manager2/list/app/284354916099194/overview?business_id=3185128691568610
  // fbq('track', 'Purchase', { value, currency: 'USD' });

  const tasks = [];

  // Report to Google Analytics
  // Note: this API includes an optional 'coupon' string field, but we might apply coupon codes to both cards and
  // videos, so we just leave it off
  tasks.push(
    new Promise(
      event_callback => gtag(
        'event',
        'purchase',
        {
          transaction_id,
          value,
          currency: 'USD',
          items,
          event_callback,
          event_timeout: 2000
        }
      )
    )
  );

  // Report to Google Ads
  // TODO: this may be redundant now that you're correctly importing conversions from Google Analytics, though it is
  // asynchronous, so there shouldn't be any real impact... Adjust your ads conversion configuration here:
  // https://ads.google.com/aw/conversions
  const cfg = process.env.OP_DEV_CONFIG;
  tasks.push(
    new Promise(
      event_callback => gtag(
        'event',
        'conversion',
        {
          send_to: `${cfg['google-ads-id']}/${cfg['google-ads-conversion-id']}`,
          transaction_id,
          value,
          currency: 'USD',
          event_callback,
          event_timeout: 2000
        }
      )
    )
  );

  $event.log('gtag-conversion', {
    send_to: `${cfg['google-ads-id']}/${cfg['google-ads-conversion-id']}`,
    transaction_id,
    value,
    currency: 'USD'
  });

  uetq.push('event', 'purchase', { 'revenue_value': value, 'currency': 'USD' });

  try {
    await Promise.all(tasks);
  } catch (e) {
    console.error('Error recording purchase', e);
  }
}


export { recordPurchase };
